module.exports = "<div class=\"alert alert-success\"> <strong>Success!</strong> Please check the email to follow further instructions from escrow.com </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/iframes/successBoxEscrow.html
 ** module id = 3
 ** module chunks = 0
 **/